import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import logoDark from '../../../assets/images/logo-dark.png';
import logoLight from '../../../assets/images/logo-light.png';
import logoIcon from '../../../assets/images/logo-icon.png';
import { FaBars, FiSettings, GrDashboard, RiLogoutCircleRLine } from '../../../assets/icons/vander';
import { useAuthentication } from "@modules/auth/hooks/use-auth.hook";
import { useProfiles } from "@modules/profiles/hooks/use-profiles.hook";
import { UserEntity } from "@modules/shared/entities/users/users.entity";
import AdProfile from "@modules/profiles/pages/adprofile";

interface SimpleBarCore {
  el: HTMLElement;
}

export default function TopHeader({ toggle, setToggle }: any) {
  const { loadProfile } = useProfiles();

  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [show, setShow] = useState(false);

  const countryDropdownRef = useRef<SimpleBarCore>(null);
  const mailDropdownRef = useRef<SimpleBarCore>(null);
  const userDropdownRef = useRef<HTMLDivElement>(null);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  const [selfProfile, setSelfProfile] = useState<UserEntity | null>(null);

  useEffect(() => {
    const fetchSelfProfile = async () => {
      const data = await loadProfile("me");
      setSelfProfile(data);
    }

    fetchSelfProfile();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (activeDropdown) {
        const isOutside =
          (activeDropdown === 'country' &&
            countryDropdownRef.current?.el &&
            !countryDropdownRef.current.el.contains(e.target as Node)) ||
          (activeDropdown === 'mail' &&
            mailDropdownRef.current?.el &&
            !mailDropdownRef.current.el.contains(e.target as Node)) ||
          (activeDropdown === 'user' &&
            userDropdownRef.current &&
            !userDropdownRef.current.contains(e.target as Node));
        if (isOutside) {
          setActiveDropdown(null);
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [activeDropdown]);

  const { logout } = useAuthentication();

  return (
    <div className="top-header">
      <div className="header-bar d-flex justify-content-between border-bottom">
        <div className="d-flex align-items-center">
          <Link to="#" className="logo-icon">
            <img src={logoIcon} height="30" className="small" alt="" />
            <span className="big">
              <img src={logoDark} height="22" className="logo-light-mode" alt="" />
              <img src={logoLight} height="22" className="logo-dark-mode" alt="" />
            </span>
          </Link>
          <Link onClick={() => setToggle(!toggle)} className="btn btn-icon btn-pills btn-soft-primary ms-2" to="#">
            <FaBars />
          </Link>
        </div>

        <ul className="list-unstyled mb-0">
          <li className="list-inline-item mb-0 ms-1">
            <div className="dropdown dropdown-primary">
              <button
                type="button"
                className="btn btn-pills btn-soft-primary dropdown-toggle p-0"
                onClick={() => setActiveDropdown(activeDropdown === 'user' ? null : 'user')}
              >
                <img src={selfProfile?.avatar?.[0]?.url || "/non-ava.png"}
                  className="avatar object-cover avatar-ex-small rounded-circle"
                  style={{
                    width: "40px",
                    height: "40px",
                    objectFit: "cover",
                  }}
                  alt="" />
              </button>
              <div
                ref={userDropdownRef}
                className={`dropdown-menu dd-menu dropdown-menu-end shadow border-0 mt-3 py-3 ${activeDropdown === 'user' ? 'show' : ''}`}
                style={{ minWidth: '200px', position: 'absolute', right: '0' }}
              >
                <Link className="dropdown-item d-flex align-items-center text-dark" to="/profile">
                  <img src={selfProfile?.avatar?.[0]?.url || "/non-ava.png"}
                    className="avatar object-cover avatar-md-sm rounded-circle border shadow"
                    style={{
                      width: "40px",
                      height: "40px",
                      objectFit: "cover",
                    }}
                    alt="" />
                  <div className="flex-1 ms-2">
                    <span className="d-block mb-1">{selfProfile?.name}</span>
                    <small className="text-muted">{selfProfile?.username}</small>
                  </div>
                </Link>
                <Link className="dropdown-item text-dark d-flex align-items-center pointer-cursor" to="/">
                  <span className="mb-0 d-inline-flex me-1"><GrDashboard className="align-middle h6 mb-0" /></span> Dashboard
                </Link>
                <div
                  style={{ cursor: "pointer" }}
                  className="dropdown-item text-dark d-flex align-items-center"
                  onClick={() => { setShow(true) }}>
                  <span className="mb-0 d-inline-block me-1">
                    <FiSettings className="align-middle h6 mb-0" />
                  </span>
                  Profile Settings
                </div>
                {show && <AdProfile show={show} setShow={setShow} />}
                <div className="dropdown-divider border-top"></div>
                <button
                  className="dropdown-item text-dark d-flex align-items-center"
                  onClick={logout}
                >
                  <span className="mb-0 d-inline-block me-1"><RiLogoutCircleRLine className="align-middle h6 mb-0" /></span> Logout
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
